/* 手机号 */
export function validMobile(str) {
    const regex = /^[1][0-9]{10}$/
    return regex.test(str)
}
/**
 * validate email
 * @param email
 * @returns {boolean}
 */
export function validateEmail(email) {
    const reg = /^([0-9a-zA-Z])+([0-9a-zA-Z\-_\\.\\+~])*@([0-9a-zA-Z])+([\\-][0-9a-zA-Z]+)*([\\.][0-9a-zA-Z]+([\\-][0-9a-zA-Z]+)*){1,8}$/;
    return reg.test(email)
}


// WEBPACK FOOTER //
// ./src/gtn/utils/validate.js